function popupRules(app) {
  return {
    tenantName: [
      {
        max: 50,
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.popup.system.tenant.label.tenantName'),
          length: 50
        }),
        trigger: 'blur'
      }
    ],
    tenantExId: [
      {
        max: 20,
        trigger: 'blur',
        message: app.$t('message.common.validation.size', {
          field: app.$t('label.popup.system.tenant.label.tenantExId'),
          length: 20
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'blur',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.popup.system.tenant.label.tenantExId'),
          type: '半角英数字'
        })
      }
    ],
  }
}
export default {
  popupRules: popupRules
}
